
import { v4 as uuidv4 } from "uuid";

const workerPool = new Map();

const run = async (simId, args) => {
  let currentNode;

  if (workerPool.has(simId)) {
    currentNode = workerPool.get(simId);
  } else {
    let spawningWorker = new Worker(new URL('./node.js', import.meta.url));

    workerPool.set(simId, spawningWorker);
    await new Promise((next) => {
      spawningWorker.onerror = (e) => {
        console.error("critical sim error")
        next();
      };
      spawningWorker.onmessage = () => {
        currentNode = spawningWorker;
        next();
      };
      spawningWorker.postMessage({ mode: "init" });
    });
  }

  currentNode.postMessage({
    mode: "sim",
    id: uuidv4(),
    payload: args,
  });

  return new Promise((resolve) => {
    currentNode.onmessage = (response) => {
      resolve(response);
    };
  });
};

const api = {
  run,
};

export default api;
